// CatalogSkeletonGrid — Platzhalter, solange Katalog-Karten laden. Er hat das Maß einer
// echten Kachel (Bild 5:7 der Rasterspalte, darunter die Chip-Zeile), damit die Liste
// beim Eintreffen der Karten nicht in die Höhe springt.
import React from 'react';
import CardGrid from '../../../ui/CardGrid';
import Skeleton from '../../../ui/Skeleton';
import './CardCatalog.css';

/**
 * Eine Platzhalter-Kachel des Rasters.
 *
 * @param {string} [label] — Text für Screenreader; nur an EINER Kachel des Rasters, sonst
 *   liest der Screenreader dieselbe Ansage sechsmal
 */
function CatalogSkeletonTile({ label }) {
  return (
    <div className="card-catalog__skeleton">
      <div className="card-catalog__skeleton-image">
        <Skeleton height="100%" radius="md" label={label} />
      </div>
      <div className="card-catalog__skeleton-chips">
        <Skeleton width="45%" height="16px" radius="pill" />
        <Skeleton width="28%" height="16px" radius="pill" />
      </div>
    </div>
  );
}

/**
 * Platzhalter-Raster im selben `CardGrid variant="browse"` wie die echten Kacheln.
 *
 * @param {number} [count] — Anzahl der Platzhalter
 * @param {string} [label] — Text für Screenreader (z. B. „Vorschläge werden geladen")
 */
export default function CatalogSkeletonGrid({ count = 6, label }) {
  return (
    <CardGrid variant="browse">
      {Array.from({ length: count }, (_, i) => (
        <CatalogSkeletonTile key={i} label={i === 0 ? label : undefined} />
      ))}
    </CardGrid>
  );
}
